import { type ReactNode } from "react";

interface Props {
  title: string;
  icon: ReactNode;
  className?: string;
}

const Title = ({ icon, title, className = "" }: Props) => {
  return (
    <h2
      className={`flex items-center gap-x-2 text-lg font-semibold ${className}`}
    >
      {icon}
      {title}
    </h2>
  );
};

export default Title;
